function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "UID",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "UI-Elements",
  transform: "translate(-1418.000000, -2802.000000)",
  fill: "currentColor"
}, React.createElement("g", {
  id: "ic-duplicate-copy",
  transform: "translate(1415.000000, 2800.000000)"
}, React.createElement("g", {
  id: "ic-duplicate"
}, React.createElement("path", {
  d: "M14.8655742,3.80307422 L13.4469258,2.38442578 C13.2007857,2.13828387 12.8669475,2 12.5188516,2 L7.8125,2 C7.08761719,2 6.5,2.58761719 6.5,3.3125 L6.5,4.625 L4.3125,4.625 C3.58761719,4.625 3,5.21261719 3,5.9375 L3,14.6875 C3,15.4123828 3.58761719,16 4.3125,16 L10.4375,16 C11.1623828,16 11.75,15.4123828 11.75,14.6875 L11.75,13.375 L13.9375,13.375 C14.6623828,13.375 15.25,12.7873828 15.25,12.0625 L15.25,4.73114844 C15.25,4.38305249 15.1117161,4.04921431 14.8655742,3.80307422 Z M10.2734375,14.6875 L4.4765625,14.6875 C4.38595328,14.6875 4.3125,14.6140467 4.3125,14.5234375 L4.3125,6.1015625 C4.3125,6.01095328 4.38595328,5.9375 4.4765625,5.9375 L6.5,5.9375 L6.5,12.0625 C6.5,12.7873828 7.08761719,13.375 7.8125,13.375 L10.4375,13.375 L10.4375,14.5234375 C10.4375,14.6140467 10.3640467,14.6875 10.2734375,14.6875 Z M13.7734375,12.0625 L7.9765625,12.0625 C7.88595328,12.0625 7.8125,11.9890467 7.8125,11.8984375 L7.8125,3.4765625 C7.8125,3.38595328 7.88595328,3.3125 7.9765625,3.3125 L10.875,3.3125 L10.875,5.71875 C10.875,6.08119141 11.1688086,6.375 11.53125,6.375 L13.9375,6.375 L13.9375,11.8984375 C13.9375,11.9890467 13.8640467,12.0625 13.7734375,12.0625 L13.7734375,12.0625 Z M13.9375,5.0625 L12.1875,5.0625 L12.1875,3.3125 L12.450875,3.3125 C12.4943789,3.3125 12.5361055,3.32978125 12.5668945,3.36054297 L13.889457,4.68310547 C13.9202235,4.71387717 13.9375,4.75561093 13.9375,4.799125 L13.9375,5.0625 L13.9375,5.0625 Z",
  id: "Shape"
})))));

var SvgIcDuplicate = function SvgIcDuplicate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcDuplicate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-duplicate.bfff17a6.svg";
export { ForwardRef as ReactComponent };